// extracted by mini-css-extract-plugin
module.exports = {"Right":"Section_Right__X4913","RightViewMode":"Section_RightViewMode__XyMr4"};